import { CheckIcon, NotAllowedIcon } from '@chakra-ui/icons';
import { CircularProgress } from '@chakra-ui/react';
import { DecisionType } from 'api';
import { AfeTransactionSummaryResponse } from 'api/bindings/AfeTransactionSummaryResponse';
import { InvoiceTransactionSummaryResponse } from 'api/bindings/InvoiceTransactionSummaryResponse';
import { PurchaseOrderTransactionSummaryResponse } from 'api/bindings/PurchaseOrderTransactionSummaryResponse';
import { WorkOrderTransactionSummaryResponse } from 'api/bindings/WorkOrderTransactionSummaryResponse';
import Decimal from 'decimal.js';
import { sumBy } from 'lodash';
import { useMemo } from 'react';

export interface ApprovalsArrayIconProps {
  txn:
    | AfeTransactionSummaryResponse
    | PurchaseOrderTransactionSummaryResponse
    | WorkOrderTransactionSummaryResponse
    | InvoiceTransactionSummaryResponse
    | undefined;
}

const size = { width: '2rem', height: '2rem' };

export const ApprovalsArrayIcon = (props: ApprovalsArrayIconProps) => {
  const { txn } = props;

  const progress = useMemo(() => {
    if (!txn || !txn.approvals?.length) return 0;

    const approvedCount = sumBy(txn.approvals, (x) =>
      x.decision === DecisionType.Approved ? 1 : 0
    );
    return new Decimal(approvedCount)
      .dividedBy(txn.approvals?.length ?? 0)
      .toNumber();
  }, [txn]);

  if (txn?.redeemed) {
    return <CheckIcon color="green.400" {...size} />;
  } else if (txn?.cancelled) {
    return <NotAllowedIcon color="red" {...size} />;
  } else {
    return (
      <CircularProgress
        value={progress}
        color="orange.400"
        size={size.height}
      />
    );
  }
};
